import React from "react";
import './style.less'
import {Tabs} from 'antd';
import { enquireScreen } from 'enquire-js';

let isMobile;
enquireScreen((b) => {
    isMobile = b;
});

const {TabPane} = Tabs;

export default class GimbalVideoContent extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div className="gimbal-video-container">
                <div className={"content"}>
                    <Tabs tabPosition={isMobile ? "top" : "left"}>
                        <TabPane tab="异地起降" key="1">
                            <div className="video-container video">
                                <video
                                    src="https://qiniu.metridynamic.com/video/cn/%E5%BC%82%E5%9C%B0%E8%B5%B7%E9%99%8D_x264.mp4"
                                    autoPlay loop muted>
                                </video>
                            </div>
                        </TabPane>
                        <TabPane tab="跟飞追踪" key="2">
                            <div className="video-container video">
                                <video
                                    src="https://qiniu.metridynamic.com/video/cn/%E7%9B%AE%E6%A0%87%E5%BC%95%E5%AF%BC%E9%A3%9E%E8%A1%8C_x264.mp4"
                                    autoPlay loop muted>
                                </video>
                            </div>
                        </TabPane>
                        <TabPane tab="远程任务共享" key="3">
                            <div className="video-container video">
                                <video
                                    src="https://qiniu.metridynamic.com/video/cn/%E8%BF%9C%E7%A8%8B%E5%8D%8F%E5%8A%A9_x264.mp4"
                                    autoPlay loop muted>
                                </video>
                            </div>
                        </TabPane>
                        <TabPane tab="实时视频回传" key="4">
                            <div className="video-container video">
                                <video
                                    src="https://qiniu.metridynamic.com/video/cn/%E5%AE%9E%E6%97%B6%E8%A7%86%E9%A2%91%E5%88%86%E4%BA%AB_x264.mp4"
                                    autoPlay loop muted>
                                </video>
                            </div>
                        </TabPane>
                        <TabPane tab="山区中继" key="5">
                            <div className="video-container video">
                                <video
                                    src="https://qiniu.metridynamic.com/video/cn/%E5%B1%B1%E5%8C%BA%E7%A9%BA%E4%B8%AD%E4%B8%AD%E7%BB%A7_x264.mp4"
                                    autoPlay loop muted>
                                </video>
                            </div>
                        </TabPane>
                        <TabPane tab="MESH组网" key="6">
                            <div className="video-container video">
                                <video
                                    src="https://qiniu.metridynamic.com/video/cn/MESH%20%E5%A4%9A%E8%8A%82%E7%82%B9%E7%BB%84%E7%BD%91_x264.mp4"
                                    autoPlay loop muted>
                                </video>
                            </div>
                        </TabPane>
                        <TabPane tab="ADS-B 民航避障播报系统" key="7">
                            <div className="video-container video">
                                <video
                                    src="https://qiniu.metridynamic.com/video/cn/ADS-B%20%E6%B0%91%E8%88%AA%E8%87%AA%E5%8A%A8%E5%B9%BF%E6%92%AD%E7%B3%BB%E7%BB%9F_x264.mp4"
                                    autoPlay loop muted>
                                </video>
                            </div>
                        </TabPane>
                        <TabPane tab="ELT应急定位器" key="8">
                            <div className="video-container video">
                                <video
                                    src="https://qiniu.metridynamic.com/video/cn/%E5%BA%94%E6%80%A5%E5%AE%9A%E4%BD%8D%E6%A8%A1%E5%9D%97_x264.mp4"
                                    autoPlay loop muted>
                                </video>
                            </div>
                        </TabPane>
                    </Tabs>
                </div>
            </div>
        )

    }
}
